import { useEffect, useState } from 'react';
import Logo from '../../react/features/AppHeader/components/Logo';
import HeaderBroadcast from '../../react/features/HeaderBroadcast';
import NavigationList from '../../react/features/Navigation/List';
import { TestDriveModeContainer } from '../../react/features/TestDriveMode';
import { useAppContext } from '../../react/hooks/useAppContext';
import Actions from '../Actions';
import styles from './style.m.less';
import TopBar from './TopBar';

type Props = {
    children: React.ReactNode;
    setShowNavigation: (show: boolean) => void;
    showNavigation: boolean;
};

export default function AppShell({ children, setShowNavigation, showNavigation }: Props) {
    const { user } = useAppContext();

    const showTestDriveMode = useShowTestDriveMode();

    return (
        <div className={styles.shell}>
            <div className={styles.container}>
                <TopBar setShowNavigation={setShowNavigation} showNavigation={showNavigation} />
                <div className={styles.navigation}>
                    <div className={styles.navigationInner} id="mainNavigation">
                        <div className={styles.navigationLogo}>
                            <Logo user={user} />
                        </div>
                        <div className={styles.navigationList}>
                            <NavigationList />
                        </div>
                        <Actions />
                    </div>
                </div>
                <div className={styles.contentWrapper}>
                    <HeaderBroadcast className={styles.broadcast} />
                    <main className={styles.content}>{children}</main>
                </div>
            </div>
            {showTestDriveMode && <TestDriveModeContainer />}
        </div>
    );
}

const useShowTestDriveMode = () => {
    const [showTestDriveMode, setShowTestDriveMode] = useState(true);

    useEffect(() => {
        const handleKeydownHideTestDrive = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key === 't') {
                setShowTestDriveMode(prev => !prev);
            }
        };

        document.addEventListener('keydown', handleKeydownHideTestDrive);

        return () => {
            document.removeEventListener('keydown', handleKeydownHideTestDrive);
        };
    }, []);

    return showTestDriveMode;
};
